import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const setToken = (token) => {
    if (token) api.defaults.headers.common.Authorization = `Bearer ${token}`;
    else delete api.defaults.headers.common.Authorization;
};

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export const split4060 = (price) => {
    const advance = Math.round(price * 0.4);
    return { advance, balance: price - advance };
};

export const waLink = (number, text) =>
    `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
